<template>
  <div class="lg_container">
    <h1>404页面</h1>
    <van-button type="info" class="lgbtn" @click="goHome">返回首页</van-button>
  </div>
</template>
<script>
export default {
  methods: {
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.lg_container {
  text-align: center;
  h1 {
    font-size: 30px;
    margin-top: 160px;
  }
  .lgbtn {
    margin: 10px auto;
    background-color: #fff;
    border-color: #fff;
    color: #60c15b;
  }
}
</style>
